import React from "react";

const InvoicePrint58 = ({ invoice }) => {
    if (!invoice) return null;

    const dateObj = new Date(invoice.createdAt);
    const date = dateObj.toLocaleDateString();
    const time = dateObj.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

    // 🔥 Reward helpers (ADDED)
    const earnedPoints = invoice.rewardPointsEarned || 0;
    const redeemedPoints = invoice.reward?.pointsUsed || 0;
    const redeemedAmount = invoice.reward?.amountRedeemed || 0;

    const payableAmount =
        invoice.totals?.payableAmount ??
        invoice.totals?.netValue;

    return (
        <div
            style={{
                width: "58mm",
                padding: "4px 6px",
                fontFamily: "'Courier New', monospace",
                fontSize: "11px",
                lineHeight: "1.25",
                color: "#000",
            }}
        >
            {/* 🔥 DUPLICATE BILL */}
            {invoice.isDuplicate && (
                <div
                    style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "14px",
                        marginBottom: "6px",
                        letterSpacing: "1px"
                    }}
                >
                    DUPLICATE BILL
                </div>
            )}

            {/* HEADER */}
            <div style={{ textAlign: "center" }}>
                <img
                    src="/assets/mayura.png"
                    alt="Logo"
                    style={{
                        width: "42px",
                        height: "42px",
                        objectFit: "contain",
                        marginBottom: "4px",
                    }}
                />

                <div style={{ fontWeight: "bold", fontSize: "13px" }}>MAYURA</div>
                <div style={{ fontSize: "11px", marginBottom: "2px" }}>
                    SILK & FASHION
                </div>
                <div style={{ fontSize: "10px" }}>
                    #171 Paneer Nagar Main Road<br />
                    Mogappair, Chennai - 600037
                </div>
                <div style={{ fontSize: "10px" }}>Ph: 950010555</div>
                <div style={{ fontSize: "10px" }}>
                    GSTIN: 33AIVPV6351J1Z1
                </div>
                <div
                    style={{
                        borderTop: "1px dashed #000",
                        marginTop: "6px",
                        marginBottom: "6px",
                    }}
                />
            </div>

            {/* BILL DETAILS */}
            <div style={{ fontSize: "10px", marginBottom: "6px" }}>
                <div><b>Bill No:</b> {invoice.invoiceNo}</div>
                <div><b>Date:</b> {date} {time}</div>
            </div>

            <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

            {/* CUSTOMER DETAILS */}
            {invoice.customerName && (
                <div style={{ fontSize: "10px", marginBottom: "6px" }}>
                    <div><b>Name:</b> {invoice.customerName}</div>
                    <div><b>Phone:</b> {invoice.customerPhone}</div>
                </div>
            )}

            <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

            {/* ITEM TABLE */}
            <table style={{ width: "100%", fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th style={{ textAlign: "left" }}>Item</th>
                        <th>Qty</th>
                        <th style={{ textAlign: "right" }}>Rate</th>
                        <th style={{ textAlign: "right" }}>Amt</th>
                    </tr>
                </thead>

                <tbody>
                    {invoice.items.map((item, index) => (
                        <tr key={index}>
                            <td style={{ maxWidth: "80px", wordBreak: "break-word" }}>
                                {item.name}
                            </td>
                            <td style={{ textAlign: "center" }}>{item.qty}</td>
                            <td style={{ textAlign: "right" }}>{item.rate}</td>
                            <td style={{ textAlign: "right" }}>
                                {Number(item.value).toFixed(2)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

            {/* TOTALS */}
            <div style={{ fontSize: "10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>Total Qty:</span>
                    <b>{invoice.totals.qty}</b>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>Total Items:</span>
                    <b>{invoice.totals.items}</b>
                </div>

                {invoice.totals.overallDiscAmount > 0 && (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>Discount:</span>
                        <b>-₹{invoice.totals.overallDiscAmount.toFixed(2)}</b>
                    </div>
                )}

                {/* 🔥 Reward Redeem (ADDED) */}
                {redeemedAmount > 0 && (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>Reward Redeemed:</span>
                        <b>-₹{redeemedAmount.toFixed(2)}</b>
                    </div>
                )}

                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>CGST:</span>
                    <b>₹{invoice.totals.totalCGST.toFixed(2)}</b>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>SGST:</span>
                    <b>₹{invoice.totals.totalSGST.toFixed(2)}</b>
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "6px",
                        fontSize: "12px",
                        fontWeight: "bold",
                    }}
                >
                    <span>Net Amount:</span>
                    <span>₹{payableAmount.toFixed(2)}</span>
                </div>
            </div>

            {/* ================= GST SUMMARY ================= */}
            <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

            <div style={{ fontSize: "10px" }}>
                <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                    GST Summary
                </div>

                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>Taxable Value</span>
                    <span>
                        ₹{(invoice.totals.grossValue ?? invoice.totals.netValue).toFixed(2)}
                    </span>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>CGST @ 2.5%</span>
                    <span>₹{invoice.totals.totalCGST.toFixed(2)}</span>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>SGST @ 2.5%</span>
                    <span>₹{invoice.totals.totalSGST.toFixed(2)}</span>
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: "bold",
                        marginTop: "4px"
                    }}
                >
                    <span>Total GST</span>
                    <span>
                        ₹{(invoice.totals.totalCGST + invoice.totals.totalSGST).toFixed(2)}
                    </span>
                </div>
            </div>


            {/* 🔥 REWARD SUMMARY (ADDED) */}
            {(earnedPoints > 0 || redeemedPoints > 0) && (
                <>
                    <div style={{ borderTop: "1px dashed #000", margin: "6px 0" }} />

                    <div style={{ fontSize: "10px" }}>
                        <b>Reward Summary</b>

                        {redeemedPoints > 0 && (
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <span>Redeemed</span>
                                <span>{redeemedPoints} pts (₹{redeemedAmount})</span>
                            </div>
                        )}

                        {earnedPoints > 0 && (
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <span>Earned</span>
                                <span>{earnedPoints} pts</span>
                            </div>
                        )}
                    </div>
                </>
            )}

            <div style={{ borderTop: "1px dashed #000", marginTop: "6px" }} />

            {/* PAYMENT BREAKUP */}
            <div style={{ fontSize: "10px", marginBottom: "6px" }}>
                <b>Payment Details</b>
                {invoice.payments.map((p, i) => (
                    <div key={i} style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>{p.paymentMethod}</span>
                        <span>₹{p.amount}</span>
                    </div>
                ))}
            </div>

            <div style={{ borderTop: "1px dashed #000", marginTop: "6px" }} />

            {/* FOOTER */}
            <div
                style={{
                    textAlign: "center",
                    fontSize: "9px",
                    marginTop: "8px",
                }}
            >
                <div>Terms & Conditions apply.</div>
                <div>No color change returns.</div>
                <div>Damaged products only returnable.</div>

                <div style={{ marginTop: "8px" }}>
                    *** THANK YOU – VISIT AGAIN ***
                </div>
            </div>
        </div>
    );
};

export default InvoicePrint58;
